import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1V2.08296C15.8377 2.55904 18 5.027 18 8H6C6 5.027 8.16229 2.55904 11 2.08296V1H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 8H2V12.8365C2.75589 12.3092 3.67517 12 4.66667 12C6.15398 12 7.47878 12.6958 8.33333 13.7796C9.18789 12.6958 10.5127 12 12 12C13.4873 12 14.8121 12.6958 15.6667 13.7796C16.5212 12.6958 17.846 12 19.3333 12C20.3248 12 21.2441 12.3092 22 12.8365V8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 16.6634C21.9983 15.1922 20.805 14 19.3333 14C17.8606 14 16.6667 15.1939 16.6667 16.6667V22H22V16.6634Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.6667 22V16.6667C14.6667 15.1939 13.4728 14 12 14C10.5272 14 9.33333 15.1939 9.33333 16.6667V22H14.6667Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.33333 22V16.6667C7.33333 15.1939 6.13943 14 4.66667 14C3.19391 14 2 15.1939 2 16.6667V22H7.33333Z"}}]};

const Castle7Filled = Vue.extend<IconProps>({
  name: 'Castle7FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'castle-7-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Castle7Filled;
